export default __webpack_public_path__ + "static/media/a011-fsi-10.88c28f5f.svg";